// Runtime polyfill for google-protobuf v3 to accept code emitted by protoc-gen-js v4.
//
// The pinned `protoc-gen-js-binary` (v1.1.0 → protoc-gen-js v4.0.2) produces stubs
// that call `readStringRequireUtf8` / `writeStringRequireUtf8` on the binary
// reader and writer. Those methods were added in `google-protobuf` v4. The
// project still ships `google-protobuf` 3.21.4 at runtime, which only has the
// older `readString` / `writeString`. The two are byte-compatible for the JS
// code-gen path (both UTF-8); aliasing the new names to the existing methods
// makes the stubs work without bumping the runtime or regressing the
// generator.
//
// Imported for side-effects from index.tsx before any proto deserialization
// can run.
var _a, _b;
import * as jspb from 'google-protobuf';
const runtime = jspb;
const readerProto = (_a = runtime.BinaryReader) === null || _a === void 0 ? void 0 : _a.prototype;
if (readerProto && !readerProto.readStringRequireUtf8 && typeof readerProto.readString === 'function') {
    readerProto.readStringRequireUtf8 = readerProto.readString;
}
const writerProto = (_b = runtime.BinaryWriter) === null || _b === void 0 ? void 0 : _b.prototype;
if (writerProto && !writerProto.writeStringRequireUtf8 && typeof writerProto.writeString === 'function') {
    writerProto.writeStringRequireUtf8 = writerProto.writeString;
}
